module.exports = __webpack_public_path__ + "static/media/Screenshot10.226f7da0.png";